/** 
 * This JS file is a customised version of 
 * vendor/elleracompany/craft-cookie-consent/src/resources/script.js
 * for the GDPR compliance feature.
 */

document.addEventListener('DOMContentLoaded', function () {
  /*
   * addEventListner: For all major browsers, except IE 8 and earlier
   * attachEvent:     For IE 8 and earlier versions
   */
  let form = document.getElementById("elc-cookie-consent-form");
  if (typeof form !== 'undefined' && form !== null) {
    if (form.addEventListener) {
      form.addEventListener("submit", submitConsent);
    } else if (form.attachEvent) {
      form.attachEvent("onsubmit", submitConsent);
    }
  }

  let tabLink = document.getElementById("elc-tab-link");
  if (typeof tabLink !== 'undefined' && tabLink !== null) {
    if (tabLink.addEventListener) {
      tabLink.addEventListener("click", toggleTab);
    } else if (tabLink.attachEvent) {
      tabLink.attachEvent("onclick", toggleTab);
    }
  }

  let closeButton = document.getElementById("elc-close-button");
  if (typeof closeButton !== 'undefined' && closeButton !== null) {
    if (closeButton.addEventListener) {
      closeButton.addEventListener("click", toggleTab);
    } else if (closeButton.attachEvent) {
      closeButton.attachEvent("onclick", toggleTab);
    }
  }
});

function injectGoogleTagManager() {
  var googleTagManagerScript = document.createElement("script");
  googleTagManagerScript.text = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','".concat(env.googleTagManagerId, "');");
  googleTagManagerScript.id = "google-tag-manager-script";

  if (!document.getElementById("google-tag-manager-script")) {
    document.head.appendChild(googleTagManagerScript);
  }
}

function injectFirebase() {
  var firebaseAppSrcipt = document.createElement("script");
  firebaseAppSrcipt.src = "https://www.gstatic.com/firebasejs/7.14.2/firebase-app.js";
  firebaseAppSrcipt.id = "firebase-app";

  var firebaseAnalyticsScript = document.createElement("script");
  firebaseAnalyticsScript.src = "https://www.gstatic.com/firebasejs/7.14.2/firebase-analytics.js";
  firebaseAnalyticsScript.id = "firebase-analytics";

  var initScript = document.createElement("script");
  initScript.text = "var firebaseConfig={apiKey:\"".concat(env.firebaseApiKey, "\",authDomain:\"").concat(env.firebaseAuthDomain, "\",databaseURL:\"").concat(env.firebaseDbUrl, "\",projectId:\"").concat(env.firebaseProjectId, "\",storageBucket:\"").concat(env.firebaseStorageBucket, "\",messagingSenderId:\"").concat(env.firebaseMessagingSenderId, "\",appId:\"").concat(env.firebaseAppId, "\",measurementId: \"").concat(env.firebaseMeasurementId, "\"};firebase.initializeApp(firebaseConfig);firebase.analytics();");
  initScript.id = "firebase-init";

  firebaseAppSrcipt.onload = function () {
    if (!document.getElementById("firebase-analytics")) {
      document.head.appendChild(firebaseAnalyticsScript);
    }
  };

  firebaseAnalyticsScript.onload = function () {
    if (!document.getElementById("firebase-init")) {
      document.head.appendChild(initScript);
    }
  };

  if (!document.getElementById("firebase-app")) {
    document.head.appendChild(firebaseAppSrcipt);
  }
}

function submitConsent(event) {

  event.preventDefault();

  let form = document.querySelector('#elc-cookie-consent-form');
  let data = serialize(form);

  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  let cookieTab = document.getElementById("elc-cookie-tab");
  if (typeof cookieTab !== 'undefined' && cookieTab !== null) document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');

  let xhr = new XMLHttpRequest();
  xhr.open('POST', form.dataset.url);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(data);

  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status !== 200) {
        console.log('Error: ' + xhr.status);
      } else {
        injectGoogleTagManager();
      }
    }
  }
}

function toggleExpand(event) {
  event.preventDefault();
  document.getElementById("elc-cookie-consent").classList.toggle('elc-fullwidth');
  document.getElementById("elc-cookie-consent").classList.toggle('elc-small');
}

function toggleTab(event) {
  event.preventDefault();
  document.getElementById("elc-cookie-consent").classList.toggle('elc-hidden');
  document.getElementById("elc-cookie-tab").classList.toggle('elc-hidden');
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {

    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');

};
